import { useEffect, useState } from "react";
import { Snackbar, Alert, Button, Box, Typography, Link } from "@mui/material";

const CookieConsentBanner = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookiesAccepted");
    if (!consent) setOpen(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookiesAccepted", "true");
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        severity="info"
        icon={false}
        sx={{
          bgcolor: "#fff",
          width: "100%",
          alignItems: "center",
          alignContent: "center",
          justifyContent: "space-between",
          display: "flex",
          flexDirection: "row",
          px: 2,
          py: 1,
        }}
        action={
          <Button
            onClick={handleAccept}
            variant="contained"
            sx={{ bgcolor: "#6E260E", color: "#fff" }}
          >
            Accept
          </Button>
        }
      >
        <Typography variant="body2">
          This website uses cookies to improve your experience. Read our{" "}
          <Link
            href="/privacy-policy"
            target="_blank"
            underline="hover"
            color="inherit"
          >
            Privacy Policy
          </Link>
          .
        </Typography>
      </Alert>
    </Snackbar>
  );
};

export default CookieConsentBanner;
